import React, {useEffect,  useState} from "react";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import { getStateByPath } from "../../redux/selectors";
import 'react-big-calendar/lib/css/react-big-calendar.css';
import EventCustomCalendar from "./EventCustomCalendar";

const ItineraryCustomModel = ({  events, onSelectEvent, onSelectSlot, path, minHour, maxHour, onDeleteItineraryItem }) => {

    const componentState = useSelector((state) => getStateByPath(state, path));
    const { listDomainObjects } = componentState?.data || [];
    const [dates, setDates] = useState([]);
    const [defaultDate, setDefaultDate] = useState(null);
    const [totalDates, setTotalDates] = useState(0);
    useEffect(() => {
        if (!listDomainObjects || listDomainObjects.length === 0) return;
        mapDatesSectionOptions();
    }, [listDomainObjects]);
    const mapDatesSectionOptions = () => {
        const _dateSectionsOptions = listDomainObjects.sort((a, b) => new Date(a.date) - new Date(b.date));
        setDates(_dateSectionsOptions);
        if (_dateSectionsOptions.length > 0) {
            const minDate = new Date(_dateSectionsOptions[0].date);
            const startDay = new Date(minDate);
            startDay.setDate(minDate.getDate() + 1);
            setDefaultDate(startDay);
            setTotalDates(_dateSectionsOptions.length);
        }
    };

    function formatDate(date) {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    }

    const eventColors = (event) => {
        const found = dates.filter(item => formatDate(new Date(event.start)) === item.date)[0];
        let color = "#000";
        if (found) {
            color = found.color;
        }
        return { style: { backgroundColor: color } };
    };

    if(defaultDate){
        return (
            <EventCustomCalendar
                onSelectSlot={onSelectSlot}
                onSelectEvent={onSelectEvent}
                onDeleteItineraryItem={onDeleteItineraryItem}
                defaultDate={defaultDate}
                events={events}
                maxDaysBySlot={7}
                minHour={minHour}
                maxHour={maxHour}
                eventColors={eventColors}
                eventDates={dates.map(item => item.date)}
            />
        );
    }
    return null;
};

ItineraryCustomModel.defaultProps = {
    events: [],
    onSelectEvent: () => {},
    onSelectSlot: () => {},
    maxHour: { hour: 23, min: 0 },
    minHour: { hour: 8, min: 0 }
};


ItineraryCustomModel.propTypes = {
    events: PropTypes.array.isRequired,
    onSelectEvent: PropTypes.func.isRequired,
    onSelectSlot: PropTypes.func.isRequired,
    maxHour: PropTypes.shape({
        hour: PropTypes.number || PropTypes.string,
        min: PropTypes.number || PropTypes.string,
    }),
    minHour: PropTypes.shape({
        hour: PropTypes.number || PropTypes.string,
        min: PropTypes.number || PropTypes.string,
    }),
};

export default ItineraryCustomModel;